import { Suspense, type PropsWithChildren } from "react";
import Loader from "./Loader";

export default function PageSuspense({ children }: PropsWithChildren) {
  return <Suspense fallback={<Loader fullPage />}>{children}</Suspense>;
}
